<template>
  <vs-card>
    <vs-table hoverFlat stripe :data="payments" search pagination max-items="15">
      <template slot="header">
        <h3>
          Fizetési módok
        </h3>
        <vs-button radius color="success" type="gradient" icon="add" @click="addPayment()"></vs-button>
      </template>
      <template slot="thead">
        <vs-th>
          Megnevezés
        </vs-th>
        <vs-th>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.PaymentName }}
          </vs-td>
          <vs-td>
            <vs-row vs-type="flex" vs-align="right" vs-justify="flex-end">
              <vs-button  v-if="parseInt(tr.Deletable) === 1" radius color="warning" size="small" type="gradient" icon="build"
                         @click="editPayment(tr.Id)"></vs-button>
              <vs-button v-if="parseInt(tr.Deletable) === 1" radius color="danger" size="small" type="gradient" icon="clear"
                         @click="delPayment(tr.Id)"></vs-button>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="centerx">
      <vs-popup classContent="addPaymentModal" title="Új fizetési mód hozzáadása" :active.sync="addModal"
                @closemodal="closeModal()">
        <new_payment v-bind:selected="selected"></new_payment>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup classContent="editPaymentModal" title="Fizetési mód módosítása" :active.sync="editModal"
                @closemodal="closeModal()">
        <edit_payment v-bind:selected="selected"></edit_payment>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import {axiosInstance} from "@/main";
import new_payment from "../../components/modals/new_payment";
import edit_payment from "../../components/modals/edit_payment";

export default {
  name: "payments",
  data() {
    return {
      payments: [],
      editModal: false,
      addModal: false,
      selected: {
        Id: '',
        PaymentName: '',
        Deletable: ''
      }
    }
  },
  components: {
    new_payment, edit_payment
  },
  methods: {
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.getPayments();
    },
    getPayments() {
      let self = this;
      axiosInstance
          .get('admin/paymentController.php', {
            withCredentials: true,
          })
          .then((response) => {
            this.payments = response.data.responseData;
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    addPayment() {
      this.selected.PaymentName = '';
      this.addModal = true;
    },
    editPayment(id) {
      this.selected = {...this.payments.find(elem => elem.Id === id)};
      this.editModal = true;
    },
    delPayment(id) {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Megerősítés`,
        text: 'Valóban törölni kívánja a fizetési módot?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .delete('admin/paymentController.php?id=' + id, {
                withCredentials: true,
              })
              .then((resp) => {
                self.getPayments();
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres törlés.' : 'Sikertelen törlés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    }
  },
  created() {
    this.getPayments();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

form {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

.vs-button {
  margin: 1px 5px;
}

</style>